import React from 'react';
import { setCurrentView } from 'core/utils';
import { AlertsViewStore } from '../stores';
import { AlertsTemplate } from 'themes/modules/alerts/pages';

@setCurrentView(rootStore => new AlertsViewStore(rootStore), 'alertsViewStore')
class Alerts extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <AlertsTemplate {...this.props} viewStore={this.props.alertsViewStore} />;
	}
}

export default Alerts;
